export default `
fragment ParagraphVideoSharepoint on ParagraphVideoSharepoint {
  id
  uuid
  entityBundle
  title
  sharepoint_url
}
`
